import { render, staticRenderFns } from "./AssignmentResult.vue?vue&type=template&id=3133dac6&scoped=true&"
import script from "./AssignmentResult.vue?vue&type=script&lang=js&"
export * from "./AssignmentResult.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentResult.vue?vue&type=style&index=0&id=3133dac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133dac6",
  null
  
)

export default component.exports